import { Notification } from 'api/userNotifications';
import { sortBy } from 'utils/functional/array';
import { values } from 'utils/functional/object';

export const sortNotifications = (
  unsortedNotifications: Array<Notification>
): Array<Notification> => {
  const [applicantNotifications, mentionNotifications, otherNotifications] =
    unsortedNotifications.reduce(
      (acc, notification) => {
        if (notification.type === 'NEW_LISTING_APPLICATION') {
          acc[0].push(notification);
        } else if (notification.type === 'MENTION_LISTING_APPLICATION') {
          acc[1].push(notification);
        } else {
          acc[2].push(notification);
        }

        return acc;
      },
      [[], [], []]
    );
  const applicantNotificationsByListingId = applicantNotifications.reduce(
    (acc, notification) => {
      if (notification.type === 'NEW_LISTING_APPLICATION') {
        const notificationListing =
          notification.data.listingApplication.listing;
        const listing = acc[notificationListing.id] || {
          type: 'NEW_APPLICATIONS_BY_LISTING',
          data: {
            ...notificationListing,
            applications: [],
            orgId: notification.about.id,
            status: notification.data.listingApplication.status,
            newCount: notification.data.listingApplication.newCount,
            count: 0,
          },
        };
        listing.data.count += 1;
        listing.created =
          acc[notificationListing.id] &&
          new Date(acc[notificationListing.id].created) >
            new Date(notification.created)
            ? acc[notificationListing.id].created
            : notification.created;
        listing.data.applications.push({
          id: notification.data.listingApplication.id,
          notificationId: notification.id,
        });
        return { ...acc, [listing.data.id]: listing };
      }

      return acc;
    },
    {}
  );
  const mentionNotificationsByApplicationId = mentionNotifications.reduce(
    (acc, notification) => {
      if (notification.type === 'MENTION_LISTING_APPLICATION') {
        const notificationApplication = notification.data.listingApplication;
        const application = acc[notificationApplication.id] || {
          type: 'NEW_MENTIONS_BY_APPLICATION',
          data: {
            ...notificationApplication,
            mentions: [],
            orgId: notification.about.id,
            status: notification.data.listingApplication.status,
            count: 0,
          },
        };
        application.data.count += 1;
        application.created =
          acc[notificationApplication.id] &&
          new Date(acc[notificationApplication.id].created) >
            new Date(notification.created)
            ? acc[notificationApplication.id].created
            : notification.created;
        application.data.mentions.push({
          id: notification.data.listingApplication.id,
          notificationId: notification.id,
        });
        return { ...acc, [application.data.id]: application };
      }

      return acc;
    },
    {}
  );
  const notifications = [
    ...otherNotifications,
    ...values(applicantNotificationsByListingId),
    ...values(mentionNotificationsByApplicationId),
  ];
  return sortBy(notifications, (n) => new Date(n.created), true);
};
